import React from "react";
import { string, object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import ProfileMenuItem from "../ProfileMenuItem";
import { staticTexts } from "../../utils/Translate";

import "./profile-menu.m.css";

const ProfileMenu = ({ type = "profile", publisherAttributes }) => (
  <div styleName="wrapper" className="profile-menu">
    <ProfileMenuItem label={staticTexts(publisherAttributes.lang).myAccout} type="outer" />
    <ProfileMenuItem
      label={staticTexts(publisherAttributes.lang).myProfile}
      isActive={type === "profile"}
      href="/profile"
    />
    <ProfileMenuItem label={staticTexts(publisherAttributes.lang).activities} type="outer" />
    <ProfileMenuItem
      label={staticTexts(publisherAttributes.lang).myComments}
      href="/my-comments"
      isActive={type === "comments"}
    />
    <ProfileMenuItem
      label={staticTexts(publisherAttributes.lang).mySavedNews}
      isNavigateIcon={true}
      isActive={type === "saved_news"}
      href="/saved"
    />
    {/* <ProfileMenuItem label={staticTexts(publisherAttributes.lang).recommenedNews} isNavigateIcon={true} isActive={type === "recommended_new"} /> */}
  </div>
);

ProfileMenu.propTypes = {
  type: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(ProfileMenu);
